import { IIcon } from '../interfaces'

const SvgComponent = ({ width = 20, height = 20, size, ...props }: IIcon) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    fill='none'
    viewBox='0 0 25 24'
    width={size || width}
    height={size || height}
    {...props}
  >
    <path
      fill='currentColor'
      d='M6.25 19h3.346v-5.943h5.308V19h3.346v-9l-6-4.52-6 4.52zm-1.5 1.5V9.25l7.5-5.645 7.5 5.645V20.5h-6.346v-5.943h-2.308V20.5z'
    />
  </svg>
)
export default SvgComponent
